import React from 'react';

import EditProductOverlay from './EditProductOverlay';
import CreateProductOverlay from './CreateProductOverlay';
import DeleteProductOverlay from './DeleteProductOverlay';

const ProductOriginFullView = (props) => {
  const { productId, productFull } = props;
  return (
    <>
      <CreateProductOverlay
        productId={productId}
        productFull={productFull}
        isProductFullView
      />
    </>
  );
};

const ProductOverlayFullView = (props) => {
  const { productId, productFull } = props;
  return (
    <>
      <EditProductOverlay productId={productId} isProductFullView />
      <DeleteProductOverlay productFull={productFull} isProductFullView />
    </>
  );
};

const ProductGrid = (props) => {
  const { productId, productFull } = props;

  return (
    <>
      <CreateProductOverlay
        productId={productId}
        productFull={productFull}
        isProductFullView={false}
      />
      <DeleteProductOverlay
        productFull={productFull}
        isProductFullView={false}
      />
    </>
  );
};

/**
 ** overlay action menu used for 3 different views
 ** 1. product origin full view
 ** 2. product overlay full view
 ** 3. product grid
 */
const OverlayActionMenuList = {
  ProductOriginFullView,
  ProductOverlayFullView,
  ProductGrid,
};

export { OverlayActionMenuList };
